export default __webpack_public_path__ + "static/ui-configurations@2x-6027e48215907b104c9c3014a4242e84.png";